import { Link } from 'react-router-dom'
import siteData from '../../data/site.json'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-neutral-800 text-neutral-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Artist Info */}
          <div>
            <h3 className="text-xl font-serif text-white mb-4">
              {siteData.siteName}
            </h3>
            <p className="text-sm text-neutral-400">
              {siteData.tagline}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">
              Kontakt
            </h4>
            <div className="space-y-2 text-sm">
              <p>
                <a
                  href={`mailto:${siteData.contact.email}`}
                  className="hover:text-white transition-colors"
                >
                  {siteData.contact.email}
                </a>
              </p>
              {siteData.contact.showPhone && (
                <p>
                  <a
                    href={`tel:${siteData.contact.phone}`}
                    className="hover:text-white transition-colors"
                  >
                    {siteData.contact.phone}
                  </a>
                </p>
              )}
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wide mb-4">
              Rechtliches
            </h4>
            <div className="space-y-2 text-sm">
              <div>
                <Link
                  to="/impressum"
                  className="hover:text-white transition-colors"
                >
                  Impressum
                </Link>
              </div>
              <div>
                <Link
                  to="/datenschutz"
                  className="hover:text-white transition-colors"
                >
                  Datenschutz
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-neutral-700 text-center">
          <p className="text-sm text-neutral-400">
            &copy; {currentYear} {siteData.siteName}. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  )
}
